import { Route, Routes } from "react-router-dom";
import "./App.css";
import useScroll from "./hooks/useScroll";
import routes from "./routes/routes";

function App() {
  const { initialLoading } = useScroll();
  return (
    <>
      {!initialLoading ? (
        <div className="App" data-scroll-container>
          <Routes>
            {routes?.map((route) => (
              <Route
                key={route?.id}
                path={route?.path}
                element={route?.element}
              />
            ))}
          </Routes>
        </div>
      ) : null}
    </>
  );
}

export default App;
